exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".create-button-container[data-v-0d20a257]{height:75px;width:140%;background-color:#fff;margin-left:-1.5rem;padding-left:26px;border-top:1px solid #cfcfcf}.chart[data-v-0d20a257]{margin-top:10px;background-color:#fff;border:1px solid #fff;color:#fff;width:100%;height:30%}.map[data-v-0d20a257]{height:100%;width:100%;background-color:green}.report-container[data-v-0d20a257]{padding-top:10px;width:100%;height:100vh;padding:0;margin:0}.column[data-v-0d20a257]{height:calc(100% - 90px)}.report-container>.row[data-v-0d20a257]{height:90%;padding-top:20px;overflow:hidden}.report-container button[data-v-0d20a257]{color:#000}.report-container .panel-title[data-v-0d20a257]{font-size:25px}.report-container .panel-footer[data-v-0d20a257]{text-align:right}.page-header[data-v-0d20a257]{background-color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0d20a257","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/report/ReportDisplay.vue
// module id = 902
// module chunks = 0